"use client"

/** @format */
import { Link, useNavigate } from "react-router-dom"
import { useState } from "react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu"
import { Button } from "../components/ui/button"
import { useSession } from "../context/SessionContext"
import { supabase } from "../supabaseClient"
import { useTranslation } from "react-i18next"
import { Avatar, AvatarFallback } from "../components/ui/avatar"
import NotificationBell from "./NotificationBell"
import AssignmentChatDialog from "./AssignmentChatDialog"
import ChatNotifications from "./ChatNotifications"
import FaqsModal from "./FaqsModal"
import { useCompanyFaqs } from "../lib/useChatPage"
import { BookOpen } from "lucide-react"
import { getAgentAbbreviation } from "../lib/chatUtils"

const Navbar = () => {
  const { t } = useTranslation()
  const {
    setActivePhone,
    setActiveNotification,
    setSelectedConversationId,
    user,
    userInfo,
    session,
  } = useSession()
  const navigate = useNavigate()
  const [testChatOpen, setTestChatOpen] = useState(false)
  // const [faqsModalOpen, setFaqsModalOpen] = useState(false)
  
  // const shouldFetchFaqs = Boolean(userInfo && session)
  // const { faqs, loading, error } = useCompanyFaqs({ 
  //   session, 
  //   userInfo: userInfo || null,
  //   enabled: shouldFetchFaqs
  // })

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut()
      localStorage.removeItem("company_id")
      if (!error) {
        navigate("/login", { replace: true })
      }
    } catch (err) {
      console.error("Error during sign-out:", err)
    }
  }

  if (!user) return null
  
  const abbreviation = userInfo ? getAgentAbbreviation(userInfo.name, false) : "—";

  return (
    <>
      <nav className="bg-white border-b">
        <div className="w-auto mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center">
                <img 
                  src="/logo_hcb.png" 
                  alt="HCB Logo" 
                  className="h-8 w-auto"
                />
              </Link>
            </div>
            
            <div className="flex items-center space-x-2">
              {/* {userInfo && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setFaqsModalOpen(true)}
                  title={t("company_faqs") || "Company FAQs"}
                >
                  <BookOpen className="h-5 w-5" />
                </Button>
              )} */}
              <ChatNotifications />
              <NotificationBell />
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" size="icon">
                    <Avatar className="w-[32px] h-[32px]">
                      <AvatarFallback className="w-[32px] h-[32px] flex items-center justify-center rounded-full bg-[#105BDB] text-white text-xs font-semibold">
                        {abbreviation}
                      </AvatarFallback>
                    </Avatar>
                    <span className="sr-only">{t("open_user_menu")}</span>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem asChild>
                    <Link
                      to="/profile"
                      onClick={() => {
                        setActiveNotification(null)
                        setActivePhone(null)
                        setSelectedConversationId(null)
                      }}
                    >
                      {t("profile")}
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={handleSignOut}>
                    {t("sign_out")}
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        </div>
      </nav>
      
      {/* {userInfo && (
        <FaqsModal
          isOpen={faqsModalOpen}
          onClose={() => setFaqsModalOpen(false)}
          faqs={faqs}
          loading={loading}
          error={error}
          session={session}
        />
      )} */}

      <AssignmentChatDialog
        isOpen={testChatOpen}
        onClose={() => setTestChatOpen(false)}
        assignedBy="test-user-123"
        assignerName="Dr. Test Usuario"
        transferId={999}
      />
    </>
  )
}

export default Navbar
